// extracted by mini-css-extract-plugin
export default {"Auth":"AuthView_Auth__kmstv","square":"AuthView_square__8tpVS"};